import React from 'react';
import ThemeControls from "./AllThemesControl";
export default function Footer(){
   const {useStyles} = ThemeControls;
   const classes = useStyles();
    return(
       <div className={classes.footer}>
        <p>@ COPYRIGHT 2025. Freezecrowd Inc ALL RIGHTS RESERVED.</p>
       </div>
    )
 }